import React from 'react'
import translate from '../../../reusable/translate'

const ValueTypeMeterContainer = React.forwardRef(({ meter, modifyMeter, disabled }, meterRef) => {
    return(
        <div ref={meterRef} style= {{borderRadius: "5px"}}>
            <div className="flex-row items-center">
                <input
                    className="report-input-number"
                    type="number"
                    placeholder={`${translate({ textKey: "sit.commitment.reports.startingLevel" })}: ${meter.startingLevel}`}
                    disabled={true}
                />
                <i className={"fas fa-chevron-right"}/>
                <input
                    className="report-input-number"
                    type="number"
                    placeholder={translate({textKey: "sit.profile.operationReport.realizedLevel"})}
                    value={meter.currentLevel}
                    onChange={(e) => modifyMeter({...meter, currentLevel: e.target.value})}
                    disabled={disabled}
                />
                <i className={"fas fa-chevron-right"}/>
                <input
                    className="report-input-number"
                    type="number"
                    placeholder={`${translate({ textKey: "sit.commitment.reports.targetLevel" })}: ${meter.targetLevel}`}
                    disabled={true}
                />
            </div>
        </div>
    )
})

export default ValueTypeMeterContainer


// WEBPACK FOOTER //
// ./src/components/profile/reports/components/ValueTypeMeterContainer.jsx